<h4 translate="services.waste.title"></h4>

<div class="btn-bar">
  <button class="btn btn-primary" [appHasAnyRole]="[AppRoles.superAdmin]"
    (click)="createDumpster()"
    translate="services.waste.actions.add">
  </button>
</div>

<div class="table-responsive">
  <table class="table table-striped"
    [attr.aria-label]="'services.waste.title' | translate">
    <thead>
      <tr>
        <th scope="col" style="min-width:150px" translate="services.waste.table.deviceId"></th>
        <th scope="col" style="min-width:225px" translate="services.waste.table.name"></th>
        <th scope="col" style="min-width:300px" translate="services.waste.table.description"></th>
        <th scope="col" style="min-width:125px" translate="services.waste.table.tenant" [appHasAnyRole]="[AppRoles.superAdmin]"></th>
        <th scope="col" style="min-width:125px" translate="services.waste.table.type" [appHasAnyRole]="[AppRoles.superAdmin]"></th>
        <th scope="col" style="min-width:125px" [appHasAnyRole]="[AppRoles.superAdmin]"></th>
      </tr>
    </thead>

    <tbody>
      @if (dumpsters.length === 0) {
        <tr>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td [appHasAnyRole]="[AppRoles.superAdmin]"></td>
          <td [appHasAnyRole]="[AppRoles.superAdmin]"></td>
          <td [appHasAnyRole]="[AppRoles.superAdmin]"></td>
        </tr>
      }

      @for (dumpster of dumpsters; track dumpster) {
        <tr>
          <td>{{dumpster.deviceId}}</td>
          <td>{{dumpster['name' + crtLang.toUpperCase()]}}</td>
          <td>{{dumpster['description' + crtLang.toUpperCase()]}}</td>
          <td [appHasAnyRole]="[AppRoles.superAdmin]">{{ dumpster.tenantCode }}</td>
          <td [appHasAnyRole]="[AppRoles.superAdmin]">{{ dumpster.dumpsterProvider }}</td>
          <td class="text-end" [appHasAnyRole]="[AppRoles.superAdmin]">
            <button class="btn btn-link btn-sm"
              (click)="openQrCode(dumpster)"
              title="{{ 'common.tooltip.displayQrCode' | translate }}">
              <fa-icon [icon]="icons.qrcode"></fa-icon>
            </button>
            <button class="btn btn-link btn-sm" type="button"
              (click)="updateDumpster(dumpster)"
              title="{{'common.tooltip.edit' | translate}}">
              <fa-icon [icon]="icons.edit"></fa-icon>
            </button>
            <button class="btn btn-link btn-sm" type="button" [appHasAnyRole]="[AppRoles.superAdmin]"
              (click)="deleteDumpster(dumpster)"
              title="{{'common.tooltip.delete' | translate}}">
              <fa-icon [icon]="icons.delete"></fa-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
